(() => {
  'use strict';
  const configElement = document.getElementById('finks-accessibility-config');
  const config = configElement ? JSON.parse(configElement.textContent) : {};
  const videoWrapper = '.fnks-2025-multi-slider__video-wrapper, .fnks-2026-heading-video__video-wrapper';
  const videoPicture = '.fnks-2025-multi-slider__thumbnail, .fnks-2026-heading-video__thumbnail';
  const carouselWrapper = '.ss__carousel__prev-wrapper, .ss__carousel__next-wrapper';

  function repair() {
    document.querySelectorAll('.acsb-trigger[role="button"]').forEach((trigger) => {
      if (!trigger.getAttribute('aria-label') && !trigger.getAttribute('aria-labelledby') && config.accessibilityOptions) {
        trigger.setAttribute('aria-label', config.accessibilityOptions);
      }
    });
    document.querySelectorAll('a[href="#acsbContent"]').forEach((link) => {
      if (!document.getElementById('acsbContent') && document.getElementById('MainContent')) {
        link.setAttribute('href', '#MainContent');
      }
    });
    document.querySelectorAll('.fnks-2025-shape-tabs__panel[aria-labelledby]').forEach((panel) => {
      if (panel.getAttribute('role') !== 'tabpanel') panel.setAttribute('role', 'tabpanel');
    });
    document.querySelectorAll('.contact-map-cards-v9 .v9-states, .contact-map-cards-v9 .v9-filters').forEach((group) => {
      if (group.getAttribute('role') !== 'group') group.setAttribute('role', 'group');
      group.querySelectorAll('button[role="tab"]').forEach((button) => button.removeAttribute('role'));
    });
    document.querySelectorAll(videoWrapper + ', ' + videoPicture).forEach((element) => {
      if (element.getAttribute('role') === 'button') element.removeAttribute('role');
      if (element.hasAttribute('tabindex')) element.removeAttribute('tabindex');
      if (element.hasAttribute('aria-label')) element.removeAttribute('aria-label');
    });
    document.querySelectorAll(carouselWrapper).forEach((wrapper) => {
      if (!wrapper.querySelector('.ss__carousel__prev[role="button"], .ss__carousel__next[role="button"], button')) return;
      if (wrapper.getAttribute('role') === 'button') wrapper.removeAttribute('role');
      if (wrapper.hasAttribute('tabindex')) wrapper.removeAttribute('tabindex');
    });
    document.querySelectorAll('div.product-single__thumbnails').forEach((list) => {
      const track = list.querySelector('.slick-track');
      if (track) {
        if (list.getAttribute('role') !== 'group') list.setAttribute('role', 'group');
        if (track.getAttribute('role') !== 'list') track.setAttribute('role', 'list');
        list.querySelectorAll('.slick-list[role="presentation"]').forEach((wrapper) => wrapper.removeAttribute('role'));
        Array.from(track.children).filter((slide) => slide.classList.contains('slick-slide')).forEach((slide) => {
          if (slide.getAttribute('role') !== 'listitem') slide.setAttribute('role', 'listitem');
        });
      } else if (list.getAttribute('role') !== 'list') list.setAttribute('role', 'list');
      list.querySelectorAll('.product-single__thumbnails-item').forEach((item) => {
        if (track && item.parentElement !== track) item.removeAttribute('role');
        else if (item.getAttribute('role') !== 'listitem') item.setAttribute('role', 'listitem');
      });
    });
    document.querySelectorAll('.wishlist-engine').forEach((wrapper) => {
      if (wrapper.querySelector('button, a[href], input, select, textarea')) {
        wrapper.removeAttribute('role');
        wrapper.removeAttribute('tabindex');
        wrapper.removeAttribute('aria-label');
      } else {
        if (wrapper.getAttribute('role') !== 'button') wrapper.setAttribute('role', 'button');
        if (wrapper.getAttribute('tabindex') !== '0') wrapper.setAttribute('tabindex', '0');
        wrapper.querySelectorAll('[role="button"], [tabindex]').forEach((child) => {
          child.removeAttribute('role');
          child.removeAttribute('tabindex');
          child.removeAttribute('aria-label');
        });
        const label = wrapper.textContent.trim().replace(/\s+/g, ' ');
        if (label && wrapper.getAttribute('aria-label') !== label) wrapper.setAttribute('aria-label', label);
      }
    });
    document.querySelectorAll('.yotpo button.yotpo-default-button[role="tab"]').forEach((button) => {
      if (!/^write-(review|question)-/.test(button.getAttribute('aria-controls') || '')) return;
      button.removeAttribute('role');
      button.removeAttribute('aria-selected');
    });
    document.querySelectorAll('.branded-specs__table table[role="presentation"]').forEach((table) => {
      table.removeAttribute('role');
    });
    document.querySelectorAll('div[data-finks-klaviyo-tracking][role="main"]').forEach((tracker) => {
      tracker.removeAttribute('role');
    });
  }

  function start() {
    repair();
    let pending = false;
    const observer = new MutationObserver((records) => {
      const relevant = records.some((record) => record.type === 'childList' || record.target.matches(
        '.acsb-trigger, .wishlist-engine *, a[href="#acsbContent"], .fnks-2025-shape-tabs__panel, .v9-states, .v9-filters, .v9-state, .v9-chip, .product-single__thumbnails, .product-single__thumbnails *, .wishlist-engine, .yotpo button.yotpo-default-button, .branded-specs__table table, div[data-finks-klaviyo-tracking], ' + videoWrapper + ', ' + videoPicture + ', ' + carouselWrapper
      ));
      if (!relevant || pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        repair();
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'tabindex', 'aria-label', 'aria-labelledby', 'href']
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#MainContent"], a[href="#acsbContent"]');
    if (!link) return;
    const main = document.getElementById('MainContent');
    if (main && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      main.scrollIntoView({ block: 'start' });
      main.focus({ preventScroll: true });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
